import { render, staticRenderFns } from "./TalentFiltering.vue?vue&type=template&id=754cad12"
import script from "./TalentFiltering.vue?vue&type=script&lang=js"
export * from "./TalentFiltering.vue?vue&type=script&lang=js"
import style0 from "./TalentFiltering.vue?vue&type=style&index=0&id=754cad12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports